(function () {
  function initialiseGallery(gallery) {
    if (gallery.hasAttribute('data-campaign-gallery-ready')) return;
    gallery.setAttribute('data-campaign-gallery-ready', 'true');

    var track = gallery.querySelector('[data-pr-mobile-gallery-track]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-pr-mobile-gallery-dot]'));
    if (!track || dots.length < 2) return;

    function hydrateImage(image) {
      if (!image || !image.hasAttribute('data-pr-lazy-image')) return;
      var srcset = image.getAttribute('data-srcset');
      var src = image.getAttribute('data-src');
      if (srcset) image.setAttribute('srcset', srcset);
      if (src) image.setAttribute('src', src);
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.removeAttribute('data-pr-lazy-image');
    }

    function hydrateAround(index) {
      [index, index + 1].forEach(function (position) {
        var slide = track.children[position];
        if (slide) hydrateImage(slide.querySelector('[data-pr-lazy-image]'));
      });
    }

    function currentIndex() {
      var width = track.clientWidth || 1;
      return Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / width)));
    }

    function setActive(index) {
      dots.forEach(function (dot, position) {
        var active = position === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var index = currentIndex();
        hydrateAround(index);
        setActive(index);
      });
    }, { passive: true });

    track.addEventListener('pointerdown', function () {
      hydrateAround(currentIndex());
    }, { once: true, passive: true });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        hydrateAround(index);
        track.scrollTo({
          left: index * (track.clientWidth || 0),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        setActive(index);
      });
    });

    setActive(0);
  }

  function initialiseCampaignShop(root) {
    var shops = root.querySelectorAll('[data-campaign-shop]:not([data-campaign-shop-ready])');

    shops.forEach(function (shop) {
      shop.setAttribute('data-campaign-shop-ready', 'true');

      var products = Array.prototype.slice.call(shop.querySelectorAll('[data-campaign-product]'));
      var count = shop.querySelector('[data-campaign-count]');

      shop.querySelectorAll('[data-pr-mobile-gallery]').forEach(initialiseGallery);
      if (count) count.textContent = products.length + (products.length === 1 ? ' style' : ' styles');
    });
  }

  initialiseCampaignShop(document);

  document.addEventListener('shopify:section:load', function (event) {
    initialiseCampaignShop(event.target);
  });
})();
